import { styled, css } from 'styled-components';
import { breakpoints, colors } from '../../../abstracts';
import { Text } from '../../Text';
import { dontForwardProps } from '../../../util';
const getCustomDashBorder = color => {
  const stroke = color.split('#')[1].toLocaleUpperCase();
  const url = `"data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg' %3E%3Crect width='100%25' height='100%25' fill='none' rx='7.5' stroke='%23${stroke}' stroke-width='1.5' stroke-linecap='round' stroke-dasharray='3 5'/%3E%3C/svg%3E"`;
  return css(["background-repeat:no-repeat;border-radius:0.5rem;background-color:transparent;border-style:none;background-image:url(", ");"], url);
};
const getButtonBackgroundColor = ({
  disabled,
  hoverState
}) => {
  if (disabled) {
    return colors.disabledBackground;
  } else if (hoverState === 'active') {
    return colors.neutralBrighter;
  } else {
    return '#ffffff';
  }
};
const getBorderStyle = ({
  disabled,
  isLoading,
  hoverState
}) => {
  if (disabled) {
    return css(["border:0.0625rem solid ", ";"], colors.neutralDeep);
  } else if (isLoading || hoverState === 'hover') {
    return getCustomDashBorder(colors.black);
  } else if (hoverState === 'active') {
    return css(["border:0.0625rem solid ", ";"], colors.black);
  } else {
    return css(["", ""], getCustomDashBorder(colors.neutralDeep));
  }
};
export const FileUploaderButton = styled.button.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1wptlnm-0"
})(["background-repeat:no-repeat;border-radius:0.5rem;position:relative;margin-bottom:0.75rem;", ";background-color:", ";", ";width:20rem;height:6.688rem;", "{width:calc(100vw - 2rem);}display:flex;flex-direction:column;align-items:center;justify-content:center;"], getBorderStyle, getButtonBackgroundColor, ({
  disabled
}) => disabled ? `cursor: not-allowed` : `cursor: pointer;`, breakpoints.xs);
export const StyledText = styled(Text).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1wptlnm-1"
})(["margin-top:", " margin-bottom:0;background-color:", ";"], ({
  isLoading
}) => isLoading ? `0.5rem;` : `0.25rem;`, getButtonBackgroundColor);
export const SecondaryLabel = styled(Text).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1wptlnm-2"
})(["margin-top:", " margin-bottom:0;color:", ";"], ({
  isLoading
}) => isLoading ? `0.5rem;` : `0.25rem;`, colors.neutralDeeper);
const getIconSvgPathFillColor = ({
  disabled,
  hoverState,
  isPrimaryAction,
  theme
}) => {
  if (disabled) return colors.neutralDeep;else if (isPrimaryAction) return colors.white;else if (hoverState == 'hover') return theme.primaryHover;else if (hoverState == 'active') return theme.primaryPressed;else return isPrimaryAction ? colors.white : theme.primary;
};
const getIconBorderColor = ({
  disabled,
  hoverState,
  theme
}) => {
  if (disabled) return colors.neutralDeep;else if (hoverState == 'hover') return theme.primaryHover;else if (hoverState == 'active') return theme.primaryPressed;else return theme.primary;
};
const getIconBackgroundColor = ({
  disabled,
  hoverState,
  isPrimaryAction,
  theme
}) => {
  if (disabled) return colors.disabledBackground;else if (hoverState == 'hover') return isPrimaryAction ? theme.primaryHover : colors.neutralBrightest;else if (hoverState == 'active') return isPrimaryAction ? theme.primaryPressed : colors.disabledBackground;else return isPrimaryAction ? theme.primary : 'transparent';
};
export const FileUploadButtonIconBorder = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1wptlnm-3"
})(["svg path{fill:", ";}span[data-aui='icon']{background-color:", ";}border-color:", ";background:", ";border-radius:10rem;height:2rem;width:2rem;display:flex;justify-content:center;align-items:center;border-style:solid;border-width:0.125rem;"], getIconSvgPathFillColor, getIconSvgPathFillColor, getIconBorderColor, getIconBackgroundColor);